import React, { Fragment } from "react";

import img13 from "../../../images/service/Decentralized Crypto Exchange Development/1.png";
import img14 from "../../../images/service/Decentralized Crypto Exchange Development/2.png";
import img15 from "../../../images/service/Decentralized Crypto Exchange Development/3.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "DEX Platform Development",
    content:
      "Custom decentralized exchange platforms powered by smart contracts and on-chain trading logic.",
  },
  {
    icon: sIcon2,
    title: "AMM & Liquidity Pool Design",
    content:
      "Automated Market Maker models with secure liquidity pool architecture.",
  },
  {
    icon: sIcon3,
    title: "Smart Contract Engineering",
    content:
      "Audited smart contracts for swaps, pools, staking, and governance.",
  },
];

const benefits = [
  {
    title: "Non-Custodial Trading",
    description:
      "Users retain full control of assets without third-party custody.",
    icon: sIcon1,
  },
  {
    title: "High Transparency",
    description:
      "All transactions and rules are executed on-chain and publicly verifiable.",
    icon: sIcon2,
  },
  {
    title: "Censorship Resistance",
    description:
      "No central authority can restrict user access or trades.",
    icon: sIcon3,
  },
  {
    title: "Global Accessibility",
    description:
      "Anyone with a wallet can trade from anywhere in the world.",
    icon: sIcon4,
  },
  {
    title: "Enhanced Security",
    description:
      "Smart contracts remove single points of failure.",
    icon: sIcon5,
  },
  {
    title: "Composable DeFi Integration",
    description:
      "Seamless integration with DeFi protocols and Web3 ecosystems.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is a decentralized crypto exchange?",
    a: "A decentralized exchange (DEX) allows users to trade cryptocurrencies directly from their wallets without intermediaries.",
  },
  {
    q: "How do DEX platforms work?",
    a: "DEX platforms use smart contracts and liquidity pools to execute trades on-chain.",
  },
  {
    q: "Are DEX platforms secure?",
    a: "Yes, when built with audited smart contracts and secure architecture.",
  },
  {
    q: "Can DEXs support multiple blockchains?",
    a: "Yes. DEX platforms can be built for Ethereum, BSC, Polygon, and multi-chain environments.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function DecentralizedCryptoExchangeDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Decentralized Crypto Exchange Development"
        pagesub="Trustless, transparent, and secure decentralized trading platforms"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build a Trustless{" "}
            <span className="gradient-text">Decentralized Crypto Exchange</span>
          </>
        }
        subtitle={`Decentralized exchanges redefine crypto trading by eliminating
intermediaries and enabling on-chain transactions. We build scalable,
secure, and feature-rich DEX platforms for the Web3 ecosystem.`}
        buttonText="Build DEX Platform"
        buttonLink="/contact"
        image={img13}
        imageAlt="Decentralized Crypto Exchange Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Decentralized Exchange Development?"
        image={img14}
        paragraphs={[
          "Decentralized exchange (DEX) development focuses on building blockchain-based trading platforms where users trade assets directly from their wallets. Unlike centralized exchanges, DEXs eliminate custodial risks by leveraging smart contracts to execute trades transparently and securely.",
          "DEX platforms rely on automated market makers (AMMs) or order-book mechanisms implemented on-chain, ensuring trustless execution and resistance to censorship.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Decentralized Exchanges Matter"
        image={img15}
        paragraphs={[
          "With increasing concerns over centralized control, security breaches, and regulatory constraints, decentralized exchanges offer a resilient alternative. They empower users with asset ownership, privacy, and global access.",
          "For businesses, DEX platforms open opportunities to build DeFi ecosystems, token economies, and permissionless trading solutions aligned with Web3 principles.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Decentralized Exchange Development Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Decentralized Crypto Exchange Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of DEX Platforms"
        subtitle="Designed for decentralization, security, and scalability."
        features={[
          {
            icon: sIcon1,
            title: "Non-Custodial Trading",
            description:
              "Users trade directly from their wallets.",
          },
          {
            icon: sIcon2,
            title: "Automated Market Makers",
            description:
              "Smart contract-driven pricing and liquidity.",
          },
          {
            icon: sIcon3,
            title: "Liquidity Pools",
            description:
              "Decentralized liquidity provisioning.",
          },
          {
            icon: sIcon4,
            title: "Multi-Chain Support",
            description:
              "Deploy across multiple blockchain networks.",
          },
          {
            icon: sIcon5,
            title: "Smart Contract Security",
            description:
              "Audited contracts to prevent exploits.",
          },
          {
            icon: sIcon6,
            title: "DAO Governance",
            description:
              "Community-driven protocol upgrades.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Deep Expertise in DeFi & DEX Development",
          "Secure & Audited Smart Contracts",
          "End-to-End DEX Launch Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
